import React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { useT } from "@/lib/LanguageContext";
import { cn } from "../../../lib/utils";
import { FOCUS_RING, PORTAL_SURFACE } from "./classes";

/**
 * The right-hand, full-height panel of the wireframes ("Add client"). Full width on a
 * phone. `data-lenis-prevent` hands wheel and touch scrolling back to the browser inside
 * the panel (lib/SmoothScroll.jsx runs Lenis on the window).
 */
export default function SlideOver({ open, onOpenChange, title, description, footer, testId, children }) {
  const t = useT("crm");
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/30" />
        <DialogPrimitive.Content
          data-testid={testId}
          data-lenis-prevent
          className={cn(
            PORTAL_SURFACE,
            "fixed inset-y-0 right-0 z-50 flex h-full w-full flex-col sm:max-w-md sm:rounded-l-3xl",
          )}
        >
          <div className="flex items-start justify-between gap-4 px-6 pt-6">
            <DialogPrimitive.Title className="font-display text-2xl leading-tight">{title}</DialogPrimitive.Title>
            <DialogPrimitive.Close className={cn("rounded-full p-1 text-eh-muted hover:text-eh-ink", FOCUS_RING)} aria-label={t("common.close")}>
              <X size={18} aria-hidden="true" />
            </DialogPrimitive.Close>
          </div>
          {description
            ? <DialogPrimitive.Description className="px-6 mt-1 text-sm text-eh-muted">{description}</DialogPrimitive.Description>
            : <DialogPrimitive.Description className="sr-only">{title}</DialogPrimitive.Description>}
          <div className="flex-1 overflow-y-auto px-6 py-4">{children}</div>
          {footer && <div className="px-6 pb-6">{footer}</div>}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
